// extracted by mini-css-extract-plugin
export default {"hideTooltip":"W--z","fadeIn":"X--z","delay":"Y--z","recommendedSizeTooltip":"Z--z"};